export const GET_PARAMETERS = 'getParameters';
export const CREATE_QUERY_PARAM = 'createQueryParam';
export const UPDATE_QUERY_PARAM = 'updateQueryParam';
export const GET_REFERENCES = 'getReferences';
export const DELETE_PARAMETER = 'deleteParameter';

export const GET_USER_VISIBLE_COLUMNS = 'getUserVisibleColumns';
